import { css, Theme } from "@mui/material";

export const pageGapMobile = "16px";
export const pageGapTablet = "24px";
export const pageGapDesktop = "32px";
export const pageGapDesktopXl = "48px";

const marginYMobile = "16px";
const marginYTablet = "64px";
const marginYDesktop = "110px";
const marginYDesktopXl = "220px";

export const pageMarginY = (theme: Theme) => css`
  ${theme.breakpoints.up("mobile")} {
    margin-left: ${marginYMobile};
    margin-right: ${marginYMobile};
  }

  ${theme.breakpoints.up("tablet")} {
    margin-left: ${marginYTablet};
    margin-right: ${marginYTablet};
  }

  ${theme.breakpoints.up("desktop")} {
    margin-left: ${marginYDesktop};
    margin-right: ${marginYDesktop};
  }

  ${theme.breakpoints.up("desktopXl")} {
    margin-left: ${marginYDesktopXl};
    margin-right: ${marginYDesktopXl};
  }
`;
